<template>
    <div :id="id" class=audio-page>

        <div class=audio-module-wrap>

            <div class=audio-module>
                <img :src="post.acf.audio_image">

                <AudioPlayer :sources="audioSources"></AudioPlayer>
            </div>

        </div>

        <PageDescription :post="post" />

    </div>
</template>
<script>
import AudioPlayer from '../components/AudioPlayer.vue';
import PageDescription from '../components/PageDescription.vue';


export default {
    name : 'AudioPage',
    props : {
        id        : String,
        post      : Object,
    },
    components : {
        AudioPlayer,
        PageDescription,
    },
    computed : {
        audioSources() {
            return [ this.post.acf.audio_file ];
        },
        theExhibitTitle() {
            return this.exhibitTitle || this.title;
        }
    },
}
</script>